import { IntegrationModel } from '@/types';

export interface MoskitIntegrationModel extends IntegrationModel {
    token: string;
    activityIds: {
        BUSY: number | null;
        DITCHED: number | null;
        ANSWERED: number | null;
        NO_ANSWER: number | null;
    };
    customFields: {
        value: string | null;
        fieldId: string | null;
        fieldType: string | null;
    };
}
